import { render, staticRenderFns } from "./SearchDetails.vue?vue&type=template&id=f9b4aa3e&scoped=true&"
import script from "./SearchDetails.vue?vue&type=script&lang=js&"
export * from "./SearchDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b4aa3e",
  null
  
)

export default component.exports